import { type MouseEventHandler } from 'react';
import { clsx } from 'clsx';
import { IconButton, type IconButtonSizeVariant } from '@hungryroot/ui-kit';
import { FavoriteHeartIcon } from './FavoriteHeartIcon';
import styles from './FavoriteHeartButton.module.css';

interface FavoriteHeartButtonProps {
  isFavorited: boolean;
  onClick: MouseEventHandler<HTMLButtonElement>;
  ariaLabel: string;
  size?: IconButtonSizeVariant;
  disabled?: boolean;
  className?: string;
  testid?: string;
}

export function FavoriteHeartButton(props: FavoriteHeartButtonProps) {
  const {
    isFavorited,
    onClick,
    ariaLabel,
    size = 'small',
    disabled = false,
    className,
    testid,
  } = props;

  return (
    <IconButton
      buttonType="button"
      style="inverted"
      prominence="primary"
      size={size}
      ariaLabel={ariaLabel}
      testid={testid}
      onClick={disabled ? undefined : onClick}
      className={clsx(styles.button, className)}
      icon={<FavoriteHeartIcon isFavorited={isFavorited} />}
    />
  );
}
